module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#login",
      toString: function () {
        return this.url;
      }
    }